import { render, staticRenderFns } from "./RetrosendLog.vue?vue&type=template&id=96a0813e"
import script from "./RetrosendLog.vue?vue&type=script&lang=js"
export * from "./RetrosendLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports